import { AppThunk } from '../../../../store/types';
import { PlayerController } from '../../../../effects/player/manager/playerController';
import { PhraseListSelectors } from '../../../../store/phrase-list/selectors';
import { PhraseListActions } from '../../../../store/phrase-list/actions';
import { PhraseEffects } from '../../../../effects/phrase/PhraseEffects';
import {
  findMaxUnionVideoPhraseByTime,
  findVideoPhraseById,
  getTargetCaptionByIndex,
} from '../../../../store/videos/selectors';
import { EVocabularyPhraseType } from '../../../../types/common';
import { ShortcutManager } from '../../../../effects/shortcut/shortcutManager';

export class PhraseListEvents {

  public static onLoadPhrases(count: number): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      return await PhraseEffects.loadPhrases(0, count, false);
    }
  }

  public static onAppendPhrases(offset: number, count: number): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      return await PhraseEffects.loadPhrases(offset, count, true);
    }
  }

  public static onTargetCaptionIndexChange(index: number): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const state = getState();
      let phraseId = 0;
      if (PlayerController.getInstance().isCaptionsPlayMode()) {
        const caption = getTargetCaptionByIndex(state, index);
        if (caption) {
          const phrase = findMaxUnionVideoPhraseByTime(state, caption.startTime, caption.endTime, [EVocabularyPhraseType.WORD_AND_CONTEXT_SELECTED]);
          if (phrase) {
            phraseId = phrase.id;
          }
        }
      }
      if (!phraseId) {
        let phrase = findVideoPhraseById(state, PhraseListSelectors.getForwardPhraseId(state))
        if (phrase && phrase.type === EVocabularyPhraseType.LESSON) {
          phraseId = phrase.id;
        }
      }

      const prevValue = PhraseListSelectors.getPlayCaptionByPhraseId(state);
      if (prevValue !== phraseId) {
        dispatch(PhraseListActions.setPlayCaptionByPhraseId(phraseId));
      }
    }
  }


  public static onKeyUp(event: KeyboardEvent): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      ShortcutManager.keyUp(event);
    }
  }

  public static onKeyDown(event: KeyboardEvent): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      ShortcutManager.keyDown(event);
    }
  }

  // public static onClickTitle(): AppThunk {
  //   return async (
  //     dispatch,
  //     getState
  //   ) => {
  //     dispatch(setMainViewMode(EMainViewMode.PHRASES));
  //     historyPush({
  //       state: { page: 'Phrases' },
  //       title: 'Phrases',
  //       onpopstate: () => dispatch(MainLayoutEffects.backToDashboard())
  //     });
  //   }
  // }

  public static onAddAnnotation(
    prevId?: number,
    nextId?: number,
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      await dispatch(PhraseEffects.addAnnotationPhrase(prevId, nextId));
    }
  }

}